import Vue from "vue";

const namespaced = true;

function initialState() {
	return {
		layouts: {}
	};
}

const state = {
	layouts: initialState().layouts
};

const mutations = {
	SET_LAYOUT: (state, layout) => {
		Vue.set(state.layouts, layout.id, layout);
	}
};

const actions = {
	create: ({ commit }, layout) => {
		return new Promise((resolve, reject) => {
			Vue.axios
				.post(`/admin/layout`, {
					layout: layout
				})
				.then(response => {
					commit("SET_LAYOUT", response.data.layout);
					resolve();
				})
				.catch(error => {
					Vue.prototype.$log.error(error);
					reject(error);
				});
		});
	},
	fetchSingle: ({ commit }, { id }) => {
		return new Promise((resolve, reject) => {
			Vue.axios
				.get(`/layout/${id}`)
				.then(response => {
					commit("SET_LAYOUT", response.data.layout);
					resolve(response.data.layout);
				})
				.catch(error => {
					Vue.prototype.$log.error(error);
					reject(error);
				});
		});
	},
	fetchAll: ({ commit }) => {
		return new Promise((resolve, reject) => {
			Vue.axios
				.get(`/layout`)
				.then(response => {
					for (const layout of response.data.layouts) {
						commit("SET_LAYOUT", layout);
					}
					resolve();
				})
				.catch(error => {
					Vue.prototype.$log.error(error);
					reject(error);
				});
		});
	},
	update: ({ commit }, layout) => {
		return new Promise((resolve, reject) => {
			Vue.axios
				.put(`/admin/layout/${layout.id}`, {
					layout: layout
				})
				.then(response => {
					commit("SET_LAYOUT", response.data.layout);
					resolve(response.data.layout);
				})
				.catch(error => {
					Vue.prototype.$log.error(error);
					reject(error);
				});
		});
	}
};

const getters = {
	all: (state, getters, rootState) => {
		if (rootState.isLoading) return {};
		return state.layouts;
	},
	asArray: (state, getters, rootState) => {
		if (rootState.isLoading) return [];
		return Object.values(state.layouts);
	}
};

export default {
	namespaced,
	state,
	mutations,
	actions,
	getters
};
